import { useQuery } from '@tanstack/react-query';
import { instance } from './config';

const getRefreshSignedCookie = async (): Promise<boolean> => {
  try {
    const response = await instance.get(`/auth/refresh-signed-cookie`);
    return response.status === 200;
  } catch (error) {
    console.error('Signed Cookie 갱신 요청 실패:', error);
    return false;
  }
};

export const useFetchRefreshSignedCookie = () => {
  const { refetch, isFetching } = useQuery({
    queryKey: ['get', '/auth/refresh-signed-cookie'],
    queryFn: () => getRefreshSignedCookie(),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: false
  });

  return { refetch, isFetching };
};

export default useFetchRefreshSignedCookie;
